/** `0:07`, `1:32` — used by the composer's recording timer, the pre-send
 * preview, and the saved comment's playback chip. */
export function formatVoiceDuration(sec: number): string {
  const m = Math.floor(sec / 60)
  const s = Math.max(0, Math.round(sec)) % 60
  return `${m}:${String(s).padStart(2, '0')}`
}

/**
 * MediaRecorder reports e.g. `audio/webm;codecs=opus`. Upload allow-lists and
 * File() constructors only want the base type.
 */
export function normalizeVoiceMimeType(mime: string | null | undefined): string {
  const base = (String(mime || '').split(';')[0] ?? '').trim().toLowerCase()
  if (base === 'audio/ogg' || base === 'audio/mp4' || base === 'audio/webm') return base
  return 'audio/webm'
}
